import { render, staticRenderFns } from "./OrganismIdcCreateEditCustomer.vue?vue&type=template&id=b9bf8cb2&scoped=true&"
import script from "./OrganismIdcCreateEditCustomer.vue?vue&type=script&lang=js&"
export * from "./OrganismIdcCreateEditCustomer.vue?vue&type=script&lang=js&"
import style0 from "./OrganismIdcCreateEditCustomer.vue?vue&type=style&index=0&id=b9bf8cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bf8cb2",
  null
  
)

export default component.exports